// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2YLcC","resendInfoText":"OnGoingPaymentBox_resendInfoText__2nvP4"};